// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fy-wizard-modal {
  padding: 24px 28px;
  max-width: 520px;
  margin: 0 auto;
  animation: fy-wizard-fade-in 200ms ease ease-out;
}
.fy-wizard-modal.fy-wizard-closing {
  animation: fy-wizard-fade-out 250ms ease-in forwards;
}

@keyframes fy-wizard-fade-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fy-wizard-fade-out {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-6px);
  }
}
.fy-wizard-header {
  text-align: center;
  margin-bottom: 24px;
  padding: 0 8px;
}
.fy-wizard-header .fy-wizard-header-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: var(--bs-primary, #2563eb);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.25);
}
.fy-wizard-header .fy-wizard-header-icon i {
  font-size: 1.75rem;
  color: #fff;
}
.fy-wizard-header .fy-wizard-title {
  font-size: 1.375rem;
  font-weight: 600;
  color: var(--bs-body-color, #1a1a1a);
  margin: 0 0 8px;
  letter-spacing: -0.02em;
  line-height: 1.35;
}
.fy-wizard-header .fy-wizard-subtitle {
  font-size: 0.9375rem;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
}

.fy-wizard-body {
  background: #f8fafc;
  border-radius: 10px;
  padding: 20px 24px;
  margin: 0 0 24px;
  border: none;
}
.fy-wizard-body .fy-wizard-step-indicator {
  margin-bottom: 12px;
}
.fy-wizard-body .fy-wizard-step-indicator .fy-wizard-step-badge {
  display: inline-block;
  padding: 6px 12px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--bs-primary, #2563eb);
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.fy-wizard-body .fy-wizard-message {
  font-size: 1rem;
  color: var(--bs-body-color, #1a1a1a);
  margin: 0 0 16px;
  line-height: 1.5;
}
.fy-wizard-body .fy-wizard-benefits {
  list-style: none;
  padding: 0;
  margin: 0;
}
.fy-wizard-body .fy-wizard-benefits li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.4;
}
.fy-wizard-body .fy-wizard-benefits li:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.fy-wizard-body .fy-wizard-benefits li i {
  color: var(--bs-success, #22c55e);
  font-size: 1rem;
  flex-shrink: 0;
}

.fy-wizard-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding-top: 8px;
}
.fy-wizard-footer .fy-wizard-dont-show {
  order: 2;
  flex: 1 1 100%;
  text-align: center;
}
@media (min-width: 520px) {
  .fy-wizard-footer .fy-wizard-dont-show {
    order: 1;
    flex: 1 1 auto;
    text-align: start;
  }
}
@media (min-width: 520px) {
  .fy-wizard-footer .fy-wizard-dont-show-rtl {
    text-align: end;
  }
}
.fy-wizard-footer .fy-wizard-actions {
  display: flex;
  gap: 12px;
  order: 1;
  flex: 1 1 100%;
  justify-content: center;
  flex-wrap: wrap;
}
@media (min-width: 520px) {
  .fy-wizard-footer .fy-wizard-actions {
    order: 2;
    flex: 0 0 auto;
    justify-content: flex-end;
  }
}

.fy-wizard-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  color: #64748b;
  -webkit-user-select: none;
          user-select: none;
}
.fy-wizard-checkbox input {
  cursor: pointer;
  width: 1rem;
  height: 1rem;
  accent-color: var(--bs-primary, #2563eb);
}
.fy-wizard-checkbox input:focus-visible {
  outline: 2px solid var(--bs-primary, #2563eb);
  outline-offset: 2px;
}

.fy-wizard-btn-primary {
  min-width: 180px;
  font-weight: 600;
  padding: 10px 20px;
  font-size: 0.9375rem;
  border-radius: 8px;
  transition: filter 200ms ease, transform 150ms ease;
}
.fy-wizard-btn-primary:hover:not(:disabled) {
  filter: brightness(1.05);
}
.fy-wizard-btn-primary:active:not(:disabled) {
  transform: scale(0.98);
}
.fy-wizard-btn-primary:focus-visible {
  outline: 2px solid var(--bs-primary, #2563eb);
  outline-offset: 2px;
}

.fy-wizard-btn-secondary {
  font-weight: 500;
  padding: 10px 16px;
  border-radius: 8px;
  transition: background 200ms ease, transform 150ms ease;
}
.fy-wizard-btn-secondary:focus-visible {
  outline: 2px solid var(--bs-primary, #2563eb);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/financial-year-onboarding-wizard/financial-year-onboarding-wizard.component.scss"],"names":[],"mappings":"AASA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gDAAA;AARF;AAUE;EACE,oDAAA;AARJ;;AAYA;EACE;IACE,UAAA;IACA,2BAAA;EATF;EAWA;IACE,UAAA;IACA,wBAAA;EATF;AACF;AAYA;EACE;IACE,UAAA;IACA,wBAAA;EAVF;EAYA;IACE,UAAA;IACA,2BAAA;EAVF;AACF;AAaA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AAXF;AAaE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAlDe;EAmDf,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;AAXJ;AAaI;EACE,kBAAA;EACA,WAAA;AAXN;AAeE;EACE,mBAAA;EACA,gBAAA;EACA,oCA/Da;EAgEb,eAAA;EACA,uBAAA;EACA,iBAAA;AAbJ;AAgBE;EACE,oBAAA;EACA,cAtEuB;EAuEvB,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAdJ;;AAkBA;EACE,mBA/EkB;EAgFlB,mBArFiB;EAsFjB,kBAAA;EACA,gBAAA;EACA,YAAA;AAfF;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,qBAAA;EACA,iBAAA;EACA,mCA9FoB;EA+FpB,iCAhGa;EAiGb,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;AAfN;AAmBE;EACE,eAAA;EACA,oCAxGa;EAyGb,gBAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAlBJ;AAoBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,cAvHqB;EAwHrB,gBAAA;AAlBN;AAoBM;EACE,4CAAA;AAlBR;AAqBM;EACE,iCAAA;EACA,eAAA;EACA,cAAA;AAnBR;;AAyBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAtBF;AAwBE;EACE,QAAA;EACA,cAAA;EACA,kBAAA;AAtBJ;AAwBI;EALF;IAMI,QAAA;IACA,cAAA;IACA,iBAAA;EArBJ;AACF;AAyBI;EADF;IAEI,eAAA;EAtBJ;AACF;AAyBE;EACE,aAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AAvBJ;AAyBI;EARF;IASI,QAAA;IACA,cAAA;IACA,yBAAA;EAtBJ;AACF;;AA0BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,cAvLyB;EAwLzB,yBAAA;UAAA,iBAAA;AAvBF;AAyBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,wCAjMe;AA0KnB;AA0BE;EACE,6CAAA;EACA,mBAAA;AAxBJ;;AA4BA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mDAAA;AAzBF;AA2BE;EACE,wBAAA;AAzBJ;AA4BE;EACE,sBAAA;AA1BJ;AA6BE;EACE,6CAAA;EACA,mBAAA;AA3BJ;;AA+BA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uDAAA;AA5BF;AA8BE;EACE,6CAAA;EACA,mBAAA;AA5BJ","sourcesContent":["// Design tokens (align with coach mark)\n$fy-wizard-radius: 10px;\n$fy-wizard-accent: var(--bs-primary, #2563eb);\n$fy-wizard-accent-subtle: rgba(37, 99, 235, 0.08);\n$fy-wizard-text: var(--bs-body-color, #1a1a1a);\n$fy-wizard-text-secondary: #64748b;\n$fy-wizard-bg-soft: #f8fafc;\n$fy-wizard-ease: 200ms ease;\n\n.fy-wizard-modal {\n  padding: 24px 28px;\n  max-width: 520px;\n  margin: 0 auto;\n  animation: fy-wizard-fade-in $fy-wizard-ease ease-out;\n\n  &.fy-wizard-closing {\n    animation: fy-wizard-fade-out 250ms ease-in forwards;\n  }\n}\n\n@keyframes fy-wizard-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fy-wizard-fade-out {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n}\n\n.fy-wizard-header {\n  text-align: center;\n  margin-bottom: 24px;\n  padding: 0 8px;\n\n  .fy-wizard-header-icon {\n    width: 64px;\n    height: 64px;\n    margin: 0 auto 16px;\n    border-radius: 50%;\n    background: $fy-wizard-accent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 16px rgba(37, 99, 235, 0.25);\n\n    i {\n      font-size: 1.75rem;\n      color: #fff;\n    }\n  }\n\n  .fy-wizard-title {\n    font-size: 1.375rem;\n    font-weight: 600;\n    color: $fy-wizard-text;\n    margin: 0 0 8px;\n    letter-spacing: -0.02em;\n    line-height: 1.35;\n  }\n\n  .fy-wizard-subtitle {\n    font-size: 0.9375rem;\n    color: $fy-wizard-text-secondary;\n    margin: 0;\n    line-height: 1.5;\n    max-width: 360px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.fy-wizard-body {\n  background: $fy-wizard-bg-soft;\n  border-radius: $fy-wizard-radius;\n  padding: 20px 24px;\n  margin: 0 0 24px;\n  border: none;\n\n  .fy-wizard-step-indicator {\n    margin-bottom: 12px;\n\n    .fy-wizard-step-badge {\n      display: inline-block;\n      padding: 6px 12px;\n      background: $fy-wizard-accent-subtle;\n      color: $fy-wizard-accent;\n      border-radius: 8px;\n      font-size: 0.8125rem;\n      font-weight: 600;\n      letter-spacing: 0.02em;\n    }\n  }\n\n  .fy-wizard-message {\n    font-size: 1rem;\n    color: $fy-wizard-text;\n    margin: 0 0 16px;\n    line-height: 1.5;\n  }\n\n  .fy-wizard-benefits {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 10px 0;\n      font-size: 0.875rem;\n      color: $fy-wizard-text-secondary;\n      line-height: 1.4;\n\n      &:not(:last-child) {\n        border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n      }\n\n      i {\n        color: var(--bs-success, #22c55e);\n        font-size: 1rem;\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n.fy-wizard-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding-top: 8px;\n\n  .fy-wizard-dont-show {\n    order: 2;\n    flex: 1 1 100%;\n    text-align: center;\n\n    @media (min-width: 520px) {\n      order: 1;\n      flex: 1 1 auto;\n      text-align: start;\n    }\n  }\n\n  .fy-wizard-dont-show-rtl {\n    @media (min-width: 520px) {\n      text-align: end;\n    }\n  }\n\n  .fy-wizard-actions {\n    display: flex;\n    gap: 12px;\n    order: 1;\n    flex: 1 1 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    @media (min-width: 520px) {\n      order: 2;\n      flex: 0 0 auto;\n      justify-content: flex-end;\n    }\n  }\n}\n\n.fy-wizard-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: $fy-wizard-text-secondary;\n  user-select: none;\n\n  input {\n    cursor: pointer;\n    width: 1rem;\n    height: 1rem;\n    accent-color: $fy-wizard-accent;\n  }\n\n  input:focus-visible {\n    outline: 2px solid $fy-wizard-accent;\n    outline-offset: 2px;\n  }\n}\n\n.fy-wizard-btn-primary {\n  min-width: 180px;\n  font-weight: 600;\n  padding: 10px 20px;\n  font-size: 0.9375rem;\n  border-radius: 8px;\n  transition: filter $fy-wizard-ease, transform 150ms ease;\n\n  &:hover:not(:disabled) {\n    filter: brightness(1.05);\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.98);\n  }\n\n  &:focus-visible {\n    outline: 2px solid $fy-wizard-accent;\n    outline-offset: 2px;\n  }\n}\n\n.fy-wizard-btn-secondary {\n  font-weight: 500;\n  padding: 10px 16px;\n  border-radius: 8px;\n  transition: background $fy-wizard-ease, transform 150ms ease;\n\n  &:focus-visible {\n    outline: 2px solid $fy-wizard-accent;\n    outline-offset: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
